import { render, staticRenderFns } from "./msginfo.vue?vue&type=template&id=496c54a6&scoped=true"
import script from "./msginfo.vue?vue&type=script&lang=js"
export * from "./msginfo.vue?vue&type=script&lang=js"
import style0 from "./msginfo.vue?vue&type=style&index=0&id=496c54a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c54a6",
  null
  
)

export default component.exports